import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SeFeAlertModule} from 'se-fe-alert';
import {SeFeButtonModule} from 'se-fe-button';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeFormFieldModule} from 'se-fe-form-field';
import {SeFeFormFieldTextModule} from 'se-fe-form-field-text';
import {SeFeFormServiceModule} from 'se-fe-form-service';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeIconModule} from 'se-fe-icon';
import {SeFeModalComponent, SeFeModalModule} from 'se-fe-modal';
import {SeFeSpinnerModule} from 'se-fe-spinner';
import {SeFeWysiwygModule} from 'se-fe-wysiwyg';
import {UpdateProductDetail} from '../../../features/product/components/product-detail/product-detail.store';
import {ItemDetailsModalComponent} from './item-details-modal/item-details-modal.component';
import {Product} from '../../../models/clare';

@Component({
  selector: 'item-details-card',
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeModalModule,
    ItemDetailsModalComponent,
    SeFeGridModule,
    SeFeFormFieldModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeFormServiceModule,
    SeFeGridModule,
    SeFeIconModule,
    SeFeSpinnerModule,
    SeFeWysiwygModule,
  ],
  templateUrl: './item-details-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './item-details-card.component.scss',
})
export class ItemDetailsCardComponent implements OnInit {
  @Input() cardName: string;
  @Input() productName: string;
  @Input() itemNumber: number | undefined;
  @Input() productDescription: string | undefined;
  @Input() product: Product | undefined;
  @Input() error: string | null;
  @Input() price: number;

  @Output() updateProductAndPriceBreak = new EventEmitter<UpdateProductDetail<{product: Product}>>();

  @ViewChild('detailModal') detailModal: SeFeModalComponent;

  productNameLabel = {label: 'Name'};
  productPriceLabel = {label: 'Price'};
  itemNumberLabel = {label: ''};
  productDescriptionLabel = {label: 'Description'};

  ngOnInit(): void {
    this.itemNumberLabel.label = this.cardName === 'Product bundle details' ? 'Bundle Code' : 'SKU';
    this.productDescription = this.getProductDescription();
  }

  onUpdateProductAndPriceBreak(event: UpdateProductDetail<{product: Product}>): void {
    this.updateProductAndPriceBreak.emit(event);
  }

  isBundle(): boolean {
    return this.cardName.toLowerCase().includes('bundle');
  }

  /**
   * Fixes an issue where the description was not wrapping correctly in the modal
   */
  getProductDescription(): string {
    return this.productDescription?.replace(/\u00A0/g, ' ').replace(/&nbsp;/g, ' ') ?? '';
  }
}
